import demandsMetaReducer from './demandsMetaReducer';

export default demandsMetaReducer;
